import axios from 'axios';

class CardVaultService {
    async getCards(type) {
        const response = await axios.get('/api/users/card_vaults', {
            params: { type }
        });

        return response.data;
    }

    async deleteCard(id) {
        const response = await axios.delete(`/api/users/card_vaults/${id}`);

        return response.data;
    }

    async getCardSaveTerms() {
        const response = await axios.get('/api/webdriver/landpage', {
            params: { tags: 'termos_de_uso_salvar_cartao' }
        });

        return response.data;
    }
}

export default new CardVaultService();
